import type { Guide } from '../types';

/** S-20.10-04 — powiadomienia imienne o wariantach (scenariusz e2e 13, BR-FTL-09). */
export const guide: Guide = {
  flagKey: 'variantNotifications',
  title: 'Powiadomienia imienne o wariantach',
  whatItDoes:
    'Autor wariantu dostaje w dzwonku i na stronie powiadomień wiadomość, gdy jego wariant zwolniono (z powodem i kto zwolnił), gdy minął termin wariantu i gdy zlecenie obsadzono jego wariantem; wnioskujący o odpięcie — gdy wniosek rozpatrzono. Powiadomienia imienne przychodzą niezależnie od obserwowanych działów, a na stronie powiadomień jest filtr „Tylko moje”.',
  audience: ['planista FTL', 'Team Leader (planista główny)'],
  presentationItems: ['S-20.10-04'],
  steps: [
    {
      route: '/notifications',
      target: 'history-unread',
      title: '„Tylko moje” na stronie powiadomień',
      description:
        'Filtr „Tylko moje” zostawia powiadomienia imienne: zwolnione warianty, minięte terminy, obsadzenia Twoim wariantem i decyzje o Twoich wnioskach.',
      action: 'Otwórz „Powiadomienia” w menu i zaznacz „Tylko moje”.',
      recorder: { account: 'ftl', actions: [{ kind: 'check', label: 'Tylko moje' }] },
    },
  ],
};
